module.exports = __webpack_public_path__ + "img/zy.c44684c3.webp";